import { createSlice } from "@reduxjs/toolkit";
import { TopMainBtnsInitialState } from "../model/TopMainBtnsReducerType";

const initialState: TopMainBtnsInitialState = {
    btnOverClassName: {
        COMMUNITY: "gnb_1da",
        BOARD: "gnb_1da",
        IMAGE: "gnb_1da"
    }
};

const slice = createSlice({
    name: "TopMainBtnsReducer",
    initialState,
    reducers: {
        setBtnOverClassName: (state, action) => {
            state.btnOverClassName = {...initialState.btnOverClassName};
            Object.keys(action.payload).forEach((key) => {
                state.btnOverClassName[key] = action.payload[key];
            });
        }
    }
});

export const TopMainBtnsActions = slice.actions;
export default slice.reducer;